import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import {
  Building2,
  DollarSign,
  Calculator,
  Landmark,
  TrendingUp,
  LogOut,
  Banknote,
} from "lucide-react";
import { ReactNode } from "react";

interface DealTabsProps {
  activeTab: string;
  onTabChange: (value: string) => void;
  children: ReactNode;
}

export function DealTabs({ activeTab, onTabChange, children }: DealTabsProps) {
  return (
    <Tabs value={activeTab} onValueChange={onTabChange} className="w-full">
      <TabsList className="grid grid-cols-7 w-full mb-6">
        <TabsTrigger value="basic" className="flex items-center gap-2">
          <Building2 className="h-4 w-4" />
          Basic
        </TabsTrigger>
        <TabsTrigger value="revenue" className="flex items-center gap-2">
          <DollarSign className="h-4 w-4" />
          Revenue
        </TabsTrigger>
        <TabsTrigger value="costs" className="flex items-center gap-2">
          <Calculator className="h-4 w-4" />
          Costs
        </TabsTrigger>
        <TabsTrigger value="payroll" className="flex items-center gap-2">
        <Banknote className="h-4 w-4" />
          Payroll
        </TabsTrigger>
        <TabsTrigger value="investment" className="flex items-center gap-2">
          <Landmark className="h-4 w-4" />
          Investment
        </TabsTrigger>
        <TabsTrigger value="financing" className="flex items-center gap-2">
          <TrendingUp className="h-4 w-4" />
          Financing
        </TabsTrigger>
        <TabsTrigger value="exit" className="flex items-center gap-2">
          <LogOut className="h-4 w-4" />
          Exit
        </TabsTrigger>
      </TabsList>
      {children}
    </Tabs>
  );
}
